import { useAllDevices } from "../../logic/hooks/useAllDevices.js";
import { useAccounts } from "../../logic/hooks/useAccounts.js";
import { useThemeSlice } from "../../components/ui/StatusBadge.jsx";
import { getManagerCardLift } from "../../components/ui/cardStyles.js";
import { DeviceManager } from "./DeviceManager.jsx";

export function DevicesPage() {
  const deviceState = useAllDevices();
  const { items: accounts } = useAccounts();
  const { c, dark } = useThemeSlice();

  const cardLift = getManagerCardLift(dark);

  return (
    <div style={{ display: "flex", flexDirection: "column", flex: 1, minHeight: 0, overflow: "hidden", padding: "14px" }}>
      <div
        style={{
          background: c.card,
          border: `1px solid ${c.cardBdr}`,
          borderRadius: 12,
          flex: 1,
          minHeight: 0,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          boxShadow: cardLift,
        }}
      >
        <DeviceManager
          {...deviceState}
          accounts={accounts}
          getAccountName={(device) => device?.accountName ?? "—"}
          emptyHint="Create a device to track hardware, SIMs, and connectivity."
        />
      </div>
    </div>
  );
}
